<template>
  <m-demo-box demo-option="intrestsPurchasing">
    <div slot="top">
      <m-demo-all-check />
    </div>
    <b-container fluid>
      <m-demo-select :propDemoType = "2" :specialDemoCategory = "3"></m-demo-select>
    </b-container>
  </m-demo-box>
</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MDemoBox from '@/components/demo/MDemoBox'
  import MDemoSelect from '@/components/demo/MDemoSelect'

  export default {
    components: {
      MDemoBox,
      MDemoSelect,
      MDemoAllCheck
    },
    data () {
      return {
        selectColumn: null
      }
    },
    created () {
      // this.$store.dispatch('demo/init')
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%
  }
  .all-hosehodls {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/DemoIntrestsPurchasing.vue